import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';
import WaypointCategoryValue from '../enums/WaypointCategoryValue';

type logCommunityWaypointsFiltersAppliedParams = {
  is_addition: boolean;
  map_location: MapLocation;
  num_categories_selected: number;
  selected_categories: WaypointCategoryValue[];
  trail_id?: string;
};

/**
 * User toggles a category checkbox under the Community waypoints overlay in the Extras tab of the map layer drawer. Fires on every change with a snapshot of all currently-selected categories.
 * @param params - Attributes to log with the amplitude event
 * @param params.is_addition - TRUE if the user added category_changed to the visible set, FALSE if it was removed.
 * @param params.map_location - The location of the map where the interaction occurred.
 * @param params.num_categories_selected - The total number of community waypoint categories currently selected after this change.
 * @param params.selected_categories - Snapshot of every community waypoint category currently selected after this change.
 * @param params.trail_id - Trail ID of the associated trail map, if applicable.
 */
const logCommunityWaypointsFiltersApplied = (
  { is_addition, map_location, num_categories_selected, selected_categories, trail_id }: logCommunityWaypointsFiltersAppliedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'community waypoints filters applied',
    {
      'is addition': is_addition,
      'map location': map_location,
      'num categories selected': num_categories_selected,
      'selected categories': selected_categories,
      'trail id': trail_id
    },
    callback
  );
};

export default logCommunityWaypointsFiltersApplied;
